import React from 'react';

const CompanyLogo = ({ company }) => {
  const logoMap = {
    LockupFixing: "/fixing-3.png",
    MelbTruss: "/logo3.png",
    PromoDoors: "/promodoors.png",
  };

  const logoSrc = logoMap[company]; // Fallback to a default logo if company doesn't match

  if (!logoSrc) return null

  return (
    <div className='absolute flex justify-center w-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[200]'>
    <img
      src={process.env.PUBLIC_URL + logoSrc}
      alt={`${company} logo`}
    />
    </div>
  );
};

export default CompanyLogo;
